const $ = require('jquery');
const timeago = require('timeago');
const get = require('lodash').get;

const timeagoRussian = (value, period) => {
  if(['minute', 'hour', 'day'].indexOf(period) == -1){
    return '';
  }
  var periodTraslations = {
    'minute' : {
      con1: ' минуту назад',
      con2: ' минуты назад',
      con3: ' минут назад',
    },
    'hour' : {
      con1: ' час назад',
      con2: ' часа назад',
      con3: ' часов назад',
    },
    'day' : {
      con1: ' день назад',
      con2: ' дня назад',
      con3: ' дней назад',
    }
  };
  if (value % 10 == 1){
    return value + periodTraslations[period].con1;
  } else if ((value % 10 >= 2) && (value % 10 < 5) && (value < 11 || value > 15)) {
    return value + periodTraslations[period].con2;
  } else {
    return value + periodTraslations[period].con3;
  }
};

const locale = get(globals, 'locale', '');
// const locale = 'ru';
const timeagoTranslations = {
  prefixAgo: (locale == 'en' ? '' : get(translations, 'txt: pirms', '')),
  prefixFromNow: '',
  suffixAgo: (locale == 'en' ? 'ago' : ''),
  suffixFromNow: '',
  today: get(translations, 'txt: šodien', ''),
  yesterday: get(translations, 'txt: vakar', ''),
  theDayBeforeYesterday: get(translations, 'txt: aizvakar', ''),
  seconds: get(translations, 'txt: dažām sekundēm', ''),
  minute: get(translations, 'txt: minūtes', ''),
  minutes: function(value){
    // If site is in russian it will return timeagoRussian function
    if (locale == 'ru'){
      return timeagoRussian(value, 'minute');
    } else {
      value = value + '';
      if (value.slice(1) == 1 && value.slice(-2) != 11){
        return get(translations, 'txt: %d minūtes', '');
      } else {
        return get(translations, 'txt: %d minūtēm', '');
      }
    }
  },
  hour: get(translations, 'txt: stundas', ''),
  hours: function(value) {
    if (locale == 'ru'){
      return timeagoRussian(value, 'hour');
    } else {
      value = value + '';
      if (value.slice(1) == 1 && value.slice(-2) != 11){
        return get(translations, 'txt: %d stundas', '');
      } else {
        return get(translations, 'txt: %d stundām', '');
      }
    }
  },
  days: function(value){
    if (locale == 'ru'){
      return timeagoRussian(value, 'day');
    } else {
      value = value + '';
      if (value.slice(1) == 1 && value.slice(-2) != 11){
        return get(translations, 'txt: %d dienas', '');
      } else {
        return get(translations, 'txt: %d dienām', '');
      }
    }
  }
};

module.exports = {
  init(classname) {
    $.timeago.settings.strings = timeagoTranslations;
    $(classname).timeago();
  },
  getTranslations() {
    return timeagoTranslations;
  }
};
